export interface PreviewSourceAudioClip {
  id: string;
  muted?: boolean | null;
  volume?: number | null;
}

export function resolvePreviewSourceAudioVolume(
  clip: PreviewSourceAudioClip,
  audibleClipId: string | null | undefined
): number {
  if (!audibleClipId || clip.id !== audibleClipId || clip.muted) return 0;
  const parsed = Number(clip.volume ?? 1);
  return Number.isFinite(parsed) ? Math.max(0, Math.min(2, parsed)) : 1;
}

/**
 * Multi-clip variant (A4): a source-video clip is audible during preview when it is in
 * the active-audible set and not muted, playing at its own per-clip volume. This mirrors
 * the render worker (worker-audio.ts), which mixes EVERY non-muted video clip's source
 * audio — not just the topmost. Returns 0 when the clip is inactive or muted so its
 * element is silenced (the caller still pauses fully-inactive elements).
 */
export function resolvePreviewSourceAudioVolumeMulti(
  clip: PreviewSourceAudioClip,
  audibleClipIds: ReadonlySet<string> | null | undefined
): number {
  if (!audibleClipIds || !audibleClipIds.has(clip.id) || clip.muted) return 0;
  const parsed = Number(clip.volume ?? 1);
  return Number.isFinite(parsed) ? Math.max(0, Math.min(2, parsed)) : 1;
}
